import React ,{useState} from 'react';
import { ReactComponent as ArrowDown } from "../../../assets/images/icon-arrow-down.svg";
import {useStyles} from "./styles";

interface IListSort {
    id: string;
    onClick: (quantity:number) => void;
    itemQuantity: number;
    SelectedQuantities:Record<string,number>
}

export function ItemQuantitySelect({
    id,
    onClick,
    itemQuantity,
    SelectedQuantities
}: IListSort) {
    const [isOpen, setIsOpen] = useState<boolean>(false)
    const classes = useStyles();
    function renderOptions(){
        const Options = [];
        for (let i = itemQuantity; i > 0; i--) {
          Options.push(
            <li key={i} onClick={()=>{
              onClick(i);
              setIsOpen(false)}} data-component-name={`ITEM_QUANTITY_${i}`}>
                 <p>{i}</p>
          </li>
          )
        }
        return Options
    }
    return <div className={classes.ItemQuantitySelectWrapper} tabIndex={-1} onBlur={()=>setIsOpen(false)}>
      <div onClick={()=>setIsOpen(!isOpen)}
         data-component-name="ITEM_QUANTITY_SELECT"
         className={isOpen ? classes.SelectedQuantity :undefined}
      >
        <ArrowDown/>
        {<p>{SelectedQuantities[id]??itemQuantity}</p> }
    </div>
    {isOpen && <ul className={classes.ItemQuantitySelectOptions}>
      {renderOptions()}
    </ul>}
    </div>
}